<template>
	<div class="classification-box">
		<div :class="[opened ? 'unselected-body' : 'unselected-body opened']">
			<div class="structureBox" v-if="isshow">
				<div class="titleName">配件 :</div>
				<div>
					<div
						v-for="(item, index) in structureList"
						:key="index"
						class="classification-wrap"
					>
						<div class="title">
							<img
								style="width: 18px; height: 18px"
								class="imgBox"
								v-bind:src="item.Code | icon"
							/>
							<span
								:class="item.Code == curId ? 'partName cur' : 'partName'"
								@click="handleStructure(item)"
								>{{ item.Name }}</span
							>
							<span
								@click="handleStructure(subItem)"
								v-for="(subItem, subIndex) in item.list"
								:key="subIndex"
								:class="subItem.ID == curId ? 'conuntName cur' : 'conuntName'"
								>{{ subItem.Name }}</span
							>
						</div>
					</div>
				</div>
				<div
					class="sx-box"
					:class="{opened: opened}"
					@click.stop="opened = !opened"
				>
					<span>{{ opened ? "收起筛选" : "更多配件" }}</span>
				</div>
			</div>
		</div>
		<!-- <div
			v-for="(item, index) in structureList"
			:key="index"
			class="classification-wrap"
		>
			<div v-if="index == 0" class="partNameTitle">配件:</div>
			<div>
				<img style="width: 18px; height: 18px" v-bind:src="item.Code | icon" />
			</div>
			<div class="title">
				<span class="title-name" @click="handleStructure(item)">{{
					item.Name
				}}</span>
				<span
					class="pointer"
					@click="handleStructure(subItem)"
					:class="{cur: subItem.ID == curId}"
					v-for="(subItem, subIndex) in item.list"
					:key="subIndex"
					>{{ subItem.Name }}</span
				>
			</div>
			<div class="content"></div>
		</div> -->
	</div>
</template>
<script>
import {VehicleStructure} from "@/api/merchant/parts"
export default {
	props: {
		curId: String
	},
	data() {
		return {
			opened: false,
			structureList: [],
			isshow: false
		}
	},
	filters: {
		icon: function (value) {
			if (!value) return ""
			switch (value) {
				case "001": //车身部分
					return require("@/assets/tourist/cs.png")
				case "002": //电器照明系统
					return require("@/assets/tourist/zm.png")
				case "003": //发动机与变速器
					return require("@/assets/tourist/fdj.png")
				case "004": //底盘部分
					return require("@/assets/tourist/dp.png")
			}
		}
	},
	created() {
		VehicleStructure().then((res) => {
			this.structureList = res
			this.isshow = true
		})
	},
	methods: {
		handleStructure(e) {
			(e, "结构")
			this.$emit("selectStructure", e)
			const {ID, Name} = e
			this.$emit("select", {type: "结构", id: ID, name: Name})
		}
	}
}
</script>
<style lang="scss" scoped>
.classification-box {
	.structureBox {
		margin-top: 14px;
		display: flex;
		// flex: 1;
		.titleName {
			width: 51px;
			font-size: 16px;
			color: #232323;
			// font-weight: 600;
			margin-right: 19px;
		}
		.classification-wrap {
			.title {
				display: flex;
				flex-wrap: wrap;

				// margin-bottom: 6px;

				.imgBox {
					margin: auto 10px auto 0;
					// margin-right: 10px;
					// margin-left: 10px;
					line-height: 1;
					align-items: center;
					vertical-align: text-bottom;
				}
				.partName {
					display: flex;
					align-items: center;
					margin-right: 14px;
					font-weight: 700;
					font-size: 16px;
					align-items: center;
					color: #232323;
					cursor: pointer;
					#cur {
						color: rgba(254, 118, 72, 1);
					}
				}
				.conuntName {
					// margin-bottom: 10px;
					line-height: 200%;
					margin-right: 24px;
					font-size: 14px;
					color: #383838;
					cursor: pointer;
				}
				.cur {
					color: rgba(254, 118, 72, 1);
				}
			}

			// .title {
			// 	display: flex;
			// 	align-items: center;
			// 	font-size: 16px;
			// 	font-weight: 600;
			// 	color: #1d2089;
			// 	.title-name {
			// 		margin-left: 8px;
			// 	}
			// }
			// .content {
			// 	margin-top: 8px;
			// 	font-size: 14px;
			// 	font-weight: 500;
			// 	line-height: 20px;
			// 	color: #1d2089;
			// 	.pointer {
			// 		cursor: pointer;
			// 		&.cur {
			// 			color: rgba(254, 118, 72, 1);
			// 		}
			// 	}
			// }
		}
		.sx-box {
			width: 100px;
			cursor: pointer;
			font-size: 16px;
			font-weight: 400;
			color: rgba(35, 35, 35, 1);
			padding-right: 8px;
			position: relative;
			&::after {
				position: absolute;
				font-family: element-icons !important;
				content: "\e6df";
				font-style: normal;
				font-weight: 600;
				font-variant: normal;
				text-transform: none;
				// line-height: 1;
				display: block;
				font-size: 22px;
				color: rgba(254, 118, 72, 1);
				transition: color 0.15s linear;
				top: 10px;
				transform: translateY(-50%);
				right: 0;
			}
			&.opened {
				&::after {
					position: absolute;
					top: 10px;
					transform: translateY(-50%) rotate(180deg);
				}
			}
		}
	}
	.unselected-body {
		// background: pink;
		height: auto;
		overflow: hidden;
		word-break: break-all; //固定高度，超过直接折行，使用overflow隐藏
		// // padding-top: 10px;
		&.opened {
			height: 64px;
			opacity: 1;
			overflow: hidden;
			// border-top: 1px dashed rgba(29, 32, 137, 1);
			// // padding-top: 10px;
			// margin-bottom: 20px;
		}

		// height: 100px;
		// opacity: 1;
		// transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
	}
	// .classification-wrap {
	// 	display: flex;
	// 	flex: 1;
	// 	margin-top: 18px;
	// 	.partNameTitle {
	// 		width: 100px;
	// 		// height: 150px;
	// 		background: pink;
	// 	}
	// 	.title {
	// 		display: flex;
	// 		// flex-wrap: wrap;
	// 		// grid-gap: 10px 20px;
	// 		// align-items: center;
	// 		// font-size: 16px;
	// 		// font-weight: 600;
	// 		color: #383838;
	// 		.title-name {
	// 			font-size: 16px;
	// 			font-weight: 600;
	// 			margin-left: 8px;
	// 		}
	// 		.pointer {
	// 			cursor: pointer;
	// 			font-size: 14px;
	// 			line-height: 20px;
	// 			color: #383838;
	// 			&.cur {
	// 				color: rgba(254, 118, 72, 1);
	// 			}
	// 		}
	// 	}
	// 	.content {
	// 		margin-top: 8px;
	// 		font-size: 14px;
	// 		font-weight: 500;
	// 		line-height: 20px;
	// 		color: #383838;
	// 	}
	// }
}
</style>
